import React from 'react';

import { usePatientPlan } from '../../../../hooks/usePatientPlans';
import { CaseType } from '../../../../services/cases/types/ICase';
import styles from '../styles.module.scss';

const CREDIT_ELIGIBLE_CASES = new Set<CaseType>([
  CaseType.video_call_instant,
  CaseType.video_call_scheduled,
  CaseType.one_report,
  CaseType.second_opinion,
  CaseType.oral_health_coaching,
  CaseType.care_coordination,
]);

const useHasPlanCredits = (casePrice?: number): boolean => {
  const { group } = usePatientPlan();
  return (
    !!group &&
    (group.unlimited || (typeof group.free_remaining === 'number' && group.free_remaining > 0)) &&
    typeof casePrice === 'number' &&
    casePrice > 0
  );
};

const PriceBlock: React.FC<{
  caseType: CaseType;
  casePrice?: number;
  children: React.ReactNode;
  hint?: React.ReactNode;
}> = ({ caseType, children, hint, casePrice }) => {
  const hasCredits = useHasPlanCredits(casePrice);
  const creditEligible = CREDIT_ELIGIBLE_CASES.has(caseType);

  if (hasCredits && creditEligible) {
    return (
      <>
        <div className={`fs-unmask ${styles.freeChip}`}>Free</div>
        <div className={`fs-unmask ${styles.coveredText}`}>Covered by your plan</div>
      </>
    );
  }

  return (
    <>
      <div className={`fs-unmask ${styles.cardPrice}`}>{children}</div>
      {hint ? <div className={`fs-unmask ${styles.cardPrice}`}>{hint}</div> : null}
    </>
  );
};

export default PriceBlock;
